// All-reviews page "Load more" behavior.
//
// Progressive enhancement: the first 10 reviews are server-rendered (see
// snippets/lm-reviews-cards.liquid). This appends the rest from window.LM_REVIEWS
// (assets/lm-reviews-data.js) in batches of 10. If anything is missing — no data,
// no button, a locked-down in-app browser that never runs this — the static 10
// stay and the button stays hidden. Nothing here throws into the page.
//
// renderCard() MUST mirror cardHtml() in scripts/gen-lm-reviews.js so appended
// cards look identical to the server-rendered ones.

(function () {
  'use strict';

  var root = document.querySelector('[data-lm-reviews]');
  if (!root) return;

  var list = root.querySelector('[data-lm-reviews-list]');
  var btn = root.querySelector('[data-lm-reviews-more]');
  var data = window.LM_REVIEWS;

  if (!list || !btn || !data || !data.length) return;

  var BATCH = 10;
  var offset = parseInt(btn.getAttribute('data-rendered'), 10) || 0;

  // Everything already on screen — leave the button hidden.
  if (offset >= data.length) return;

  function makeStars(rating) {
    var wrap = document.createElement('div');
    wrap.className = 'lm-reviews__stars';
    wrap.setAttribute('role', 'img');
    wrap.setAttribute('aria-label', rating + ' out of 5 stars');
    for (var i = 1; i <= 5; i++) {
      var star = document.createElement('span');
      star.className = 'lm-reviews__star' + (i <= rating ? ' is-on' : '');
      star.textContent = '★';
      wrap.appendChild(star);
    }
    return wrap;
  }

  function span(cls, text) {
    var el = document.createElement('span');
    el.className = cls;
    el.textContent = text;
    return el;
  }

  function renderCard(r) {
    var card = document.createElement('article');
    card.className = 'lm-reviews__card';

    card.appendChild(makeStars(r.rating));

    var head = document.createElement('div');
    head.className = 'lm-reviews__head';
    head.appendChild(span('lm-reviews__name', r.name));
    head.appendChild(span('lm-reviews__date', r.date));
    head.appendChild(span('lm-reviews__badge', 'via Etsy'));
    card.appendChild(head);

    var text = document.createElement('p');
    text.className = 'lm-reviews__text';
    text.textContent = r.text;
    card.appendChild(text);

    return card;
  }

  function loadMore() {
    var frag = document.createDocumentFragment();
    var end = Math.min(offset + BATCH, data.length);
    for (var i = offset; i < end; i++) {
      frag.appendChild(renderCard(data[i]));
    }
    list.appendChild(frag);
    offset = end;
    if (offset >= data.length) btn.hidden = true;
  }

  btn.addEventListener('click', loadMore);
  // Reveal now that JS is live and there's more to show.
  btn.hidden = false;
})();
